/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Annotation_RulesInputs */



/**
* | output |
* | --- |
* | "Annotation rules" |
*
* @param {Pricing_Compare_Annotation_RulesInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_annotation_rules = /** @type {((inputs?: Pricing_Compare_Annotation_RulesInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Annotation_RulesInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Правила аннотаций")
	return /** @type {LocalizedString} */ ("Annotation rules")
});